<div class="login-footer-item">
    Need Support? Call &nbsp;
    
    <ng-container *ngFor="let callCenterPhoneNumber of callCenterPhoneNumbers; last as isLast">
        <span>
            <span *ngIf="callCenterPhoneNumbers.length > 1 && isLast">&nbsp;or</span>
            <b>
                <a [href]="'tel:+' + callCenterPhoneNumber.phoneNumber">
                    {{callCenterPhoneNumber.phoneNumber}}
                </a>
            </b>
            <span *ngIf="callCenterPhoneNumber.name">({{callCenterPhoneNumber.name}})</span>
            <span *ngIf="callCenterPhoneNumbers.length > 2 && !isLast">,&nbsp;</span>
         </span>
    </ng-container>
</div>
